<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span>下线操作</span>
      </div>
      <el-alert
          type="warning"
          :closable="false"
          title="点击下线后，业绩查询页面的所有登录将立即失效，用户需要重新登录。出单 H5 等其他入口不受影响。"
          style="margin-bottom: 20px;">
      </el-alert>
      <el-form inline size="mini">
        <el-form-item label="上次下线时间：">
          <span>{{ lastOfflineTime }}</span>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="handleOffline">下线操作</el-button>
          <el-button @click="loadOfflineInfo">刷新</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import moment from "moment-timezone";
import {defaultTimeZone} from "@/utils/constants";

export default {
  data() {
    return {
      notBefore: 0,
    }
  },

  computed: {
    lastOfflineTime() {
      if (!this.notBefore) return '从未执行过下线';
      return moment(this.notBefore).tz(defaultTimeZone).format('YYYY-MM-DD HH:mm:ss');
    }
  },

  mounted() {
    this.loadOfflineInfo();
  },

  methods: {
    async loadOfflineInfo() {
      try {
        const res = await this.$axios.post('/tools/offlineInfo', {});
        this.notBefore = res.notBefore || 0;
      } catch (e) {
        // ignore
      }
    },

    async handleOffline() {
      try {
        await this.$confirm('确定要让业绩查询页面的所有登录立即失效吗？用户需要重新登录。', '下线操作', {
          type: 'warning',
          confirmButtonText: '确定下线',
          cancelButtonText: '取消',
        });
        await this.$axios.post('/tools/offlineAll', {});
        this.$message.success('已下线，业绩查询页面的用户需重新登录');
        this.loadOfflineInfo();
      } catch (e) {
        // 用户取消或请求失败
      }
    },
  }
}
</script>
